import { PartnerIDs } from '@/enums/partner'

export function usePartnerList () {
  function sortPartners (partnerData = []) {
    return partnerData.sort((a, b) => a.id - b.id)
  }

  function filterPartners (partnerData = [], enablePartners = []) {
    const enabledIDs = new Set(enablePartners.map(p => p.partner_id))
    return sortPartners(partnerData).filter(partner => partner.id !== PartnerIDs.Eatigo).filter(partner => enabledIDs.size ? enabledIDs.has(partner.id) : true)
  }

  return {
    sortPartners,
    filterPartners
  }
}
